import { render, staticRenderFns } from "./company-follow.vue?vue&type=template&id=fcd89c4e&scoped=true"
import script from "./company-follow.vue?vue&type=script&lang=js"
export * from "./company-follow.vue?vue&type=script&lang=js"
import style0 from "./company-follow.vue?vue&type=style&index=0&id=fcd89c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd89c4e",
  null
  
)

export default component.exports